module.exports = __webpack_public_path__ + "static/media/teke-los-angeles.231be43a.jpg";